/* eslint-disable */
import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'
// react components for routing our app without refresh
import { Link } from 'gatsby'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Icon from '@material-ui/core/Icon'
import Hidden from '@material-ui/core/Hidden'

// @material-ui/icons
import StoreIcon from '@material-ui/icons/Store'
import OpacityIcon from '@material-ui/icons/Opacity'
import HomeWorkIcon from '@material-ui/icons/HomeWork'
import HotTubIcon from '@material-ui/icons/HotTub'
import KitchenIcon from '@material-ui/icons/Kitchen'
import PowerIcon from '@material-ui/icons/Power'
import ViewDay from '@material-ui/icons/CalendarViewDay'

// core components
import CustomDropdown from 'components/CustomDropdown/CustomDropdown.js'
import Button from 'components/CustomButtons/Button.js'
import { LANDING, BANOS, COCINAS, LOCALES, PISOS, ELECTRICISTAS, FONTANEROS, PRESUPUESTO, CONTENEDORES, CARGADORES } from 'constants/routes';
import styles from 'assets/jss/styles/components/headerLinksStyle.js'

const useStyles = makeStyles(styles)

export default function HeaderLinks(props) {
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t + b
    t--
    return (-c / 2) * (t * (t - 2) - 1) + b
  }

  const smoothScroll = (e, target) => {
    if (window.location.pathname === '/sections') {
      var isMobile = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
      )
      if (isMobile) {
        // if we are on mobile device the scroll into view will be managed by the browser
      } else {
        e.preventDefault()
        var targetScroll = document.getElementById(target)
        scrollGo(document.documentElement, targetScroll.offsetTop, 1250)
      }
    }
  }
  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20

    var animateScroll = function() {
      currentTime += increment
      var val = easeInOutQuad(currentTime, start, change, duration)
      element.scrollTop = val
      if (currentTime < duration) {
        setTimeout(animateScroll, increment)
      }
    }
    animateScroll()
  }
  var onClickSections = {}

  const { dropdownHoverColor } = props
  const classes = useStyles()
  return (
    <List className={classes.list + ' ' + classes.mlAuto}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Instalaciones"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          dropdownList={[
            <Link to={CARGADORES} title="Cargadores Coches Eléctricos">
              <span className={classes.dropdownLink}>
                <PowerIcon className={classes.dropdownIcons} /> Cargadores Coches Eléctricos
              </span>
            </Link>
          ]}
        />
      </ListItem>

      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Construcción"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          dropdownList={[
            <Link to={CONTENEDORES}>
              <span className={classes.dropdownLink}>
                <HomeWorkIcon className={classes.dropdownIcons} /> Construcción con contenedores marítimos
              </span>
            </Link>
          ]}
        />
      </ListItem>

      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Reformas"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          dropdownList={[
            <Link to={LOCALES}>
              <span className={classes.dropdownLink}>
                <StoreIcon className={classes.dropdownIcons} /> Reformas de Locales
              </span>
            </Link>,
            <Link to={PISOS}>
              <span className={classes.dropdownLink}>
                <HomeWorkIcon className={classes.dropdownIcons} /> Reformas de pisos
              </span>
            </Link>,
            <Link to={COCINAS}>
              <span className={classes.dropdownLink}>
                <KitchenIcon className={classes.dropdownIcons} /> Reformas de cocinas
              </span>
            </Link>,
            <Link to={BANOS}>
              <span className={classes.dropdownLink}>
                <HotTubIcon className={classes.dropdownIcons} /> Reformas de baños
              </span>
            </Link>,
            <Link to={ELECTRICISTAS}>
              <span className={classes.dropdownLink}>
                <PowerIcon className={classes.dropdownIcons} /> Instalaciones eléctricas
              </span>
            </Link>,
            <Link to={FONTANEROS}>
              <span className={classes.dropdownLink}>
                <OpacityIcon className={classes.dropdownIcons} /> Fontanería
              </span>
            </Link>,
          ]}
        />
      </ListItem>

      <ListItem className={classes.listItem}>
        <Hidden mdDown>
          <Link to={PRESUPUESTO}>
            <Button color={'white'} className={classes.navButton} round>
              Pide Presupuesto
            </Button>
          </Link>
        </Hidden>
        <Hidden mdUp>
          <Link to={PRESUPUESTO}>
            <Button color={'info'} className={classes.navButton} round>
              Pide Presupuesto
            </Button>
          </Link>
        </Hidden>
      </ListItem>
    </List>
  )
}

HeaderLinks.defaultProps = {
  hoverColor: 'primary',
}

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    'dark',
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'rose',
  ]),
}
